export default __webpack_public_path__ + "static/media/chatWidgetImg.5a885627.png";